
import React, { useState, useRef, useEffect } from 'react';
import Nav from './Nav'
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';

function HeaderTwo() {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
  
        window.addEventListener('scroll', handleScroll);
  
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
  
    const [isOpen, setIsOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('english');
    const pickerRef = useRef(null);
  
    const languages = [
      { lang: 'de', value: 'deutsch', label: 'Deutsch' },
      { lang: 'en', value: 'english', label: 'English' },
      { lang: 'fr', value: 'francais', label: 'Français' },
      { lang: 'it', value: 'italiano', label: 'Italiano' }
    ];
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (pickerRef.current && !pickerRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      const handleKeyUp = (event) => {
        if (event.key === 'Escape') {
          setIsOpen(false);
        }
      };
  
      window.addEventListener('click', handleClickOutside);
      window.addEventListener('keyup', handleKeyUp);
  
      return () => {
        window.removeEventListener('click', handleClickOutside);
        window.removeEventListener('keyup', handleKeyUp);
      };
    }, []);
  
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };
  
    const handleLanguageChange = (language) => {
      setSelectedLanguage(language.value);
      setIsOpen(false);
      // Handle redirection or other actions based on language selection
    };
  
    // side menu active
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  
    const handleMenuToggle = () => {
      setIsMenuVisible(!isMenuVisible);
      setIsOverlayVisible(!isOverlayVisible);
    };
  
    const handleCloseMenu = () => {
      setIsMenuVisible(false);
      setIsOverlayVisible(false);
    };
  
    const handleOverlayClick = () => {
      setIsMenuVisible(false);
      setIsOverlayVisible(false);
    };
  
  
  
    // mobile menu
    const [openMenu, setOpenMenu] = useState(null);
  
    const toggleMenu = (menuhome) => {
        setOpenMenu(openMenu === menuhome ? null : menuhome);
    };
  
  return (
    <div>
            {/* tpm-header-area start */}
            <header className={`tmp-header-area-start header-two header--sticky ${isSticky ? 'sticky' : ''}`}>
                {/* header mid area start */}
                <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                    <div className="header-mida-area style-two">
                        <div className="logo-area-start">
                        <Link to={'/'}>
                            <img src="assets/images/logo/AQv.svg" alt="logo" />
                        </Link>
                        </div>
                        <Nav/>
                        <div className="button-area-header-two">
                        <Link to={"/Contact"} className="tmp-btn btn-secondary">
                            Get Consulting
                        </Link>
                        <div className="actions-area">
                            <div className="tmp-side-collups-area" id="side-collups" onClick={handleMenuToggle}>
                            <svg
                                width={20}
                                height={16}
                                viewBox="0 0 20 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect y={14} width={20} height={2} fill="#1F1F25" />
                                <rect y={7} width={20} height={2} fill="#1F1F25" />
                                <rect width={20} height={2} fill="#1F1F25" />
                            </svg>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                {/* header mid area end */}
            </header>
            {/* tpm-header-area end */}


            <div id="side-hide" className={isMenuVisible ? 'show' : ''}>
            <div className="top-area">
                <a href="index.html" className="logo-area">
                <img src="assets/images/logo/AQ5.png" alt="logo" />
                </a>
                <div className="close-icon-area">
                <div id="close-slide__main" onClick={handleOverlayClick}>
                    <i className="fa-solid fa-x" />
                </div>
                </div>
            </div>
            <div className="body">
                <h5 className="title">Transforming your ideas into digital reality</h5>
                <p className="disc">
                Sed ut perspiciatis unde omnis natus error voluptatem santium doloremque
                laudantium, totam rem aperiam, eaque.
                </p>
                <div className="short-contact-area-side-collups">
                {/* single contact information */}
                <div className="single-contact-information-side">
                    <i className="fa-solid fa-phone" />
                    <div className="information">
                    <span>Call Now</span>
                    <a href="#" className="number">
                        +92 (8800) - 98670
                    </a>
                    </div>
                </div>
                {/* single contact information end */}
                {/* single contact information */}
                <div className="single-contact-information-side">
                    <i className="fa-light fa-envelope" />
                    <div className="information">
                    <span>Mail Us</span>
                    <a href="#" className="number">
                        example@info.com
                    </a>
                    </div>
                </div>
                {/* single contact information end */}
                {/* single contact information */}
                <div className="single-contact-information-side">
                    <i className="fa-sharp fa-light fa-location-dot" />
                    <div className="information">
                    <span>Our Address</span>
                    <a href="#" className="number">
                        66 Broklyant, New York 3269
                    </a>
                    </div>
                </div>
                {/* single contact information end */}
                </div>
                {/* social area start */}
                <ul className="social-icons solid-social-icons rounded-social-icons">
                <li>
                    <a href="#">
                    <i className="fa-brands fa-facebook-f" />
                    </a>
                </li>
                <li>
                    <a href="#">
                    <i className="fa-brands fa-linkedin-in" />
                    </a>
                </li>
                <li>
                    <a href="#">
                    <i className="fa-brands fa-twitter" />
                    </a>
                </li>
                <li>
                    <a href="#">
                    <i className="fa-brands fa-instagram" />
                    </a>
                </li>
                </ul>
                {/* social area end */}
            </div>
            
            {/* mobile menu area start */}
            <div className="mobile-menu-main">
            <nav className="nav-main mainmenu-nav mt--30">
                <ul className="mainmenu metismenu" id="mobile-menu-active">


                    <li className="">
                        <Link to="/home-two" className="main" onClick={() => toggleMenu(1)}>
                            Home
                        </Link>
                        {/* <ul className={`submenu ${openMenu === 1 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/home-one">
                                    Corporate Demo
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-two">
                                    Home Two
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-three">
                                    Home Three
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-four">
                                    Home Four
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-five">
                                    Home Five
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-six">
                                    Home Six
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-seven">
                                    Home Seven
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-eight">
                                    Home Eight
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-nine">
                                    Home Nine
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-ten">
                                    Home Ten
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/home-eleven">
                                    Home Eleven
                                </Link>
                            </li>
                        </ul> */}
                    </li>
                    <li className="">
                        <Link to="/About" className="main" onClick={() => toggleMenu(2)}>
                            About us
                        </Link>
                        {/* <ul className={`submenu ${openMenu === 2 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/about">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/team">
                                    Affiliate
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/faq">
                                    Pricing
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/book-a-demo">
                                    Sign Up
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/free-audit">
                                    Whois
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/pricing">
                                    Partner
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/blog">
                                    Blog
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/blog-list">
                                    Blog List
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/blog-grid-2">
                                    Blog Grid
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/support">
                                    Support
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/pricing">
                                    Pricing
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/pricing-two">
                                    Pricing Package
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/pricing-three">
                                    Pricing Comparison
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/signin">
                                    Sign In
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/business-mail">
                                    Business Mail
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/knowledgebase">
                                    Knowledgebase
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/blog-details">
                                    Blog Details
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-checker">
                                    Domain Checker
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/ssl-certificate">
                                    SSL Certificates
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/data-center">
                                    Data Centers
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/technology">
                                    Technology
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/contact">
                                    Contact
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-transfer">
                                    Domain Transfer
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/payment-method">
                                    Payment Method
                                </Link>
                            </li>
                        </ul> */}
                    </li>
                    <li className="">
                        <Link to="/ServiceDetails" className="main" onClick={() => toggleMenu(3)}>
                            Services
                        </Link>
                        {/* <ul className={`submenu ${openMenu === 3 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/shared-hosting">
                                    Shared Hosting
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/wordpress-hosting">
                                    WordPress Hosting
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/vps-hosting">
                                    VPS Hosting
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/reseller-hosting">
                                    Reseller Hosting
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/dedicated-hosting">
                                    Dedicated Hosting
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/cloud-hosting">
                                    Cloud Hosting
                                </Link>
                            </li>
                        </ul> */}
                    </li>
                    <li className="">
                        <Link to="/Project" className="main" onClick={() => toggleMenu(4)}>
                            Gallery
                        </Link>
                        {/* <ul className={`submenu ${openMenu === 4 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-checker">
                                    Domain Checker
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-transfer">
                                    Domain Transfer
                                </Link>
                            </li>
                        </ul> */}
                    </li>
                    <li className="">
                        <Link to="/ProjectDetails" className="main" onClick={() => toggleMenu(4)}>
                            Solutions
                        </Link>
                        {/* <ul className={`submenu ${openMenu === 4 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-checker">
                                    Domain Checker
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-transfer">
                                    Domain Transfer
                                </Link>
                            </li>
                        </ul> */}
                    </li>
                    <li className="">
                        <Link to="/Contact" className="main" onClick={() => toggleMenu(4)}>
                            Contact us
                        </Link>
                        {/* <ul className={`submenu ${openMenu === 4 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-checker">
                                    Domain Checker
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/domain-transfer">
                                    Domain Transfer
                                </Link>
                            </li>
                        </ul> */}
                    </li>
                    {/* <li className="has-droupdown">
                        <Link to="#" className="main" onClick={() => toggleMenu(5)}>
                            Technology
                        </Link>
                        <ul className={`submenu ${openMenu === 5 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/technology">
                                    Technology
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/data-center">
                                    Data Center
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/game-details">
                                    Game Details
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className="has-droupdown">
                        <Link to="#" className="main" onClick={() => toggleMenu(6)}>
                            Help Center
                        </Link>
                        <ul className={`submenu ${openMenu === 6 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                            <li>
                                <Link className="mobile-menu-link" to="/knowledgebase">
                                    Knowledgebase
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="hosting-offer-one">
                                    Ads Banner
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/whois">
                                    Whois
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/support">
                                    Support
                                </Link>
                            </li>
                            <li>
                                <Link className="mobile-menu-link" to="/contact">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </li> */}
                </ul>
            </nav>
            </div>
            {/* mobile menu area end */}
            </div>

            <div id="overlay_every-where" className={isOverlayVisible ? 'bgshow' : ''}
            onClick={handleOverlayClick}></div>
    </div>
  )
}

export default HeaderTwo